
const Routes = {
    Dashboard: {
        Get: () => '/api/Dashboard/Get/',
        GetPotentialViolations: () => '/api/Dashboard/PotentialViolations/',
        TopLeakRates: (IsExport) => '/api/Dashboard/TopLeakRates?IsExport=' + (IsExport ? 'true' : 'false'),
        TopLeakRatesDropdowns: () => '/api/Dashboard/TopLeakRatesDropdowns',
        AssetsDueForInspectionDropdown: () => '/api/Dashboard/AssetsDueForInspectionDropdown',
        OldestOpenWorkOrders: () => '/api/Dashboard/OldestOpenWorkOrders/',
        ExportOpenWorkOrders: () => '/api/Dashboard/OpenWorkOrdersExport/',
        OpenWorkOrdersFilters: () => '/api/Dashboard/OpenWorkOrdersFilters/',
        AssetsUnderRepair: () => '/api/Dashboard/AssetsUnderRepair/',
        AssetsDueForInspection: (IsExport) => 'api/Dashboard/AssetsDueForInspection?IsExport=' + (IsExport ? 'true' : 'false'),
        UnderRepairSystems: (IsExport) => '/api/Dashboard/UnderRepairSystems?IsExport=' + (IsExport ? 'true' : 'false'),
        UnderRepairSystemsDropdown: () => '/api/Dashboard/UnderRepairSystemsDropdown',
        ServiceHistory: () => '/api/Dashboard/ServiceHistory/ ',
        Search: (device) => '/api/Dashboard/Search/' + (device ? '?device=' + encodeURIComponent(device) : ''),
        ChronicallyLeaky: (IsExport) => '/api/Dashboard/ChronicallyLeakySystems?IsExport=' + (IsExport ? 'true' : 'false'),
        ChronicallyLeakyDropdown: () => '/api/Dashboard/ChronicallyLeakyDropdown/',
        EPA30Day: (IsExport) => '/api/Dashboard/EPA30Day?IsExport=' + (IsExport ? 'true' : 'false'),
        EPA30DayDropdown: () => '/api/Dashboard/EPA30DayDropdown',
        EPALeakRateTrigger: (IsExport) => '/api/Dashboard/EPALeakRateTrigger?IsExport=' + (IsExport ? 'true' : 'false'),
        EPALeakRateTriggerDropdown: () => '/api/Dashboard/EPALeakRateTriggerDropdown',
        FailedFollowUpVerification: () => '/api/Dashboard/FailedFollowUpVerification/',
        LeakDetector350Days: (IsExport) => '/api/Dashboard/LeakDetector350Days?IsExport=' + (IsExport ? 'true' : 'false'),
        LeakDetector350DaysDropdown: () => '/api/Dashboard/LeakDetector350DaysDropdown',
        YearlyLeakInspectionViolations: (IsExport) => '/api/Dashboard/YearlyLeakInspectionViolations?IsExport=' + (IsExport ? 'true' : 'false'),
        YearlyLeakInspectionViolationsDropdown: () => '/api/Dashboard/YearlyLeakInspectionViolationsDropdown',
        LeakInspectionFilters: () => '/api/Dashboard/LeakInspectionFilters',
        LeakInspectionSummary: () => '/api/Dashboard/LeakInspectionSummary',
        LeakInspectionLocations: (isExport) => `/api/Dashboard/LeakInspectionLocations?IsExport=${isExport ? 'true' : 'false'}`,
        LeakInspectionAssets: (isExport) => `/api/Dashboard/LeakInspectionAssets?IsExport=${isExport ? 'true' : 'false'}`,
    },
    Account: {
        Login: () => '/api/Account/Login',
        Logout: () => '/api/Account/Logout',
        GetAccountDetails: (includeOptions = false) => `/api/Account/GetAccountDetails?includeOptions=${includeOptions}`,
        GetInstanceInfo: () => '/api/Account/GetInstanceInfo',
        GetUserInfo: () => '/api/Account/GetUserInfo',
        GetUserInfoLogin: (emailOrUserName) => '/api/Account/GetUserInfoLogin/' + emailOrUserName,
        GetUserInstances: () => '/api/Account/GetUserInstances',
        UserTable: () => '/api/Account/UserTable',
        UserTableExport: () => '/api/Account/UserTableExport',
        UserTableFilters: () => '/api/Account/UserTableFilters',
        ChangeInstance: () => '/api/Account/ChangeInstance',
        ForgotPassword: () => '/api/Account/ForgotPassword',
        ChangePassword: () => '/api/Account/ChangePassword',
        ChangePasswordMyProfile: () => '/api/Account/ChangePassword/MyProfile',
        ValidatePasswordChange: () => '/api/Account/ValidatePasswordChange',
        UpdateAccountDetails: (id) => `/api/Account/UpdateAccountDetails/${id}`,
        DeleteAccount: (id) => `/api/Account/DeleteAccount/${id}`,
        RecordPageView: () => '/api/Account/RecordPageView',
        SystemManagersTable: () => '/api/Account/SystemManagersTable',
        ExportSystemManagersTable: () => '/api/Account/ExportSystemManagersTable',
        SystemManagerUpsert: () => '/api/Account/SystemManager/Upsert',
        SystemManagerDelete: () => '/api/Account/SystemManager/delete',
        WebHookLogs: () => '/api/Account/WebHookLogs',
        WebHookLogFilters: () => '/api/Account/WebHookLogFilters',
    },
    InstanceSSO: {
        InstanceSSOTable: () => '/api/InstanceSSO/Table',
        EditInstanceSSO: () => '/api/InstanceSSO/InstanceSSOSave',
    },
    Asset: {
        AssetTable: () => '/api/Asset/Table',
        TableFilters: () => '/api/Asset/TableFilters',
        TableExport: () => '/api/Asset/TableExport',
        Details: (id) => '/api/Asset/Details/' + id,
        AddAssetDropdowns: () => '/api/Asset/AddAssetDropdowns',
        GetLeakMonitorDevices: (id) => "/api/Asset/GetLeakMonitorDevices/" + id,
        CreateAsset: () => '/api/Asset/CreateAsset',
        ServiceEventHistory: (id) => 'api/Asset/ServiceEventTable/' + id,
        ServiceEventHistoryExport: (id) => 'api/Asset/ServiceEventTable/Export/' + id,
        Warranty: (id) => 'api/Asset/Warranty/' + id,
        WarrantyNumbers: (id) => 'api/Asset/Warranty/' + id,
        CreateWarranty: () => 'api/Asset/CreateAssetWarranty',
        GetMaterialTransfer: (id) => 'api/Asset/MaterialTransfer/' + id,
        GetCylinderReweigh: (id) => 'api/Asset/CylinderReweigh/' + id,
        GetCylinderStatusHistory: (id) => 'api/Asset/RecoverCylinderStatus/' + id,
        RecoverCylinderStatusFilters: (id) => 'api/Asset/RecoverCylinderStatusFilters/' + id,
        GetAssetMovement: (id) => 'api/Asset/AssetMovement/' + id,
        GetAssetMovementExport: (id) => 'api/Asset/AssetMovement/Export/' + id,
        DeleteWarranty: () => 'api/Asset/DeleteWarranty/',
        WarrantyRequirements: (id) => 'api/Asset/WarrantyRequirements/' + id,
        DeleteWarrantyRequirement: () => 'api/Asset/DeleteWarrantyRequirement/',
        CreateWarrantyRequirement: () => 'api/Asset/CreateAssetWarrantyRequirement',
        FetchRecoveryCylinders: (id, primaryTechnicianID) => `api/Asset/FetchRecoveryCylinders/${id}/${primaryTechnicianID}`,
        FetchInstallCylinders: (id, primaryTechnicianID) => `api/Asset/FetchInstallCylinders/${id}/${primaryTechnicianID}`,
        FetchInstallCylindersForRetrofit: (id, primaryTechnicianID, newMaterialTypeID) =>
            `api/Asset/reFetchInstallCylindersForRetrofit/${id}/${primaryTechnicianID}/${newMaterialTypeID}`,
        FetchAfterServiceStatusOptions: (assetStatusID) => `api/Asset/FetchAfterServiceStatusOptions/${assetStatusID}`,
        MoveCylinders: (newLocationId, dateMoved, isRecycling) =>
            `/api/Asset/MoveCylinders/${newLocationId}/${dateMoved}/${isRecycling}`,
        CreateReweigh: () => 'api/Asset/CreateReweigh',
        FetchMoveCylinderFilterValues: () => 'api/Asset/FetchMoveCylinderFilterValues',
        FetchContactEPAFilterValues: () => '/api/Asset/FetchContactEPAFilterValues',
        GetRelatedAsset: (id) => 'api/Asset/RelatedAssets/' + id,
        GetPossibleRelationships: (assetId, relationshipTypeId) => 'api/Asset/PossibleRelationships/' + assetId + '/' + relationshipTypeId,
        CreateAssetRelationship: () => 'api/Asset/CreateAssetRelationship',
        DeleteAssetRelationship: () => 'api/Asset/DeleteAssetRelationship',
        CreateLeakRateExceed: () => 'api/Asset/CreateLeakRate',
        UpdateLeakRateExceed: () => 'api/Asset/UpdateLeakRate',
        DeleteLeakRateExceed: (id) => `api/Asset/DeleteLeakRate/${id}`,
        GetLeakRateExceed: (assetId) => `api/Asset/GetLeakRate/${assetId}`,

        GetApplianceDisposal: (id) => `api/Asset/GetApplianceDisposal/${id}`,
        UpdateApplianceDisposal: () => 'api/Asset/UpdateApplianceDisposal',
        DeleteApplianceDisposal: (id) => `api/Asset/DeleteApplianceDisposal/${id}`,
        ApplianceDisposalTable: () => 'api/Asset/ApplianceDisposalTable',
        ApplianceDisposalExport: () => 'api/Asset/ApplianceDisposalExport',
        BulkUpdate: () => 'api/Asset/BulkUpdate',
        GetBatchUpdateExport: () => 'api/Asset/GetBatchUpdateExport',
        DeleteAsset: (id) => `api/Asset/DeleteAsset/${id}`,
        GetRelatedAssets: (id) => `api/Asset/RelatedAssets/${id}`,
        GetRelatedAssetsTableLookups: () => 'api/Asset/RelatedAssetsTableLookups',
        ExportRelatedAssets: (id) => `api/Asset/ExportRelatedAssets/${id}`,
        AddSensor: () => `api/Asset/AddSensor`,
        GetLinkCoolingApplianceTable: (id) => `api/Asset/GetLinkCoolingApplianceTable/${id}`,
        GetLinkCoolingApplianceDropdown: (id) => `api/Asset/GetLinkCoolingApplianceDropdown/${id}`,
        UpdateLinkCoolingAppliance: (id) => `api/Asset/UpdateLinkCoolingAppliance`,
        GetCylinderTransferDropdowns: (id) => `api/Asset/GetCylinderTransferDropdowns/${id}`,
        CreateCylinderTransfer: (id) => `api/Asset/CreateCylinderTransfer`,
        DecommissionAsset: () => 'api/Asset/DecommissionAsset',
    },
    SystemRegistration: {
        TableFilters: () => 'api/SystemRegistration/GetTableFilters',
        Table: (assetId) => `api/SystemRegistration/Table/${assetId}`,
        TableExport: (assetId) => `api/SystemRegistration/TableExport/${assetId}`,
        GetById: (id) => `api/SystemRegistration/GetById/${id}`,
        Create: () => 'api/SystemRegistration/Create',
        Update: () => 'api/SystemRegistration/Update',
        Delete: (id) => `api/SystemRegistration/Delete/${id}`,
    },
    Comment: {
        GetComments: (type, id) => `api/Comment/${type}/${id}`,
        AddComment: () => 'api/Comment/',
        DeleteComment: () => 'api/Comment/DeleteComment',
        EditComment: () => 'api/Comment/EditComment',
    },
    Authentication: {
        CheckAuthenticated: () => '/api/Authentication/CheckAuthenticated'
    },
    Location: {
        LocationTable: () => '/api/Location/Table',
        LocationTableFilters: () => '/api/Location/LocationTableFilters',
        LocationTableExport: () => '/api/Location/TableExport',
        Details: (id) => '/api/Location/Details/' + id,
        SubLocations: (id) => '/api/Location/GetSubLocations/' + id,
        SaveSubLocations: (id) => '/api/Location/SaveSubLocations/' + id,
        DetailsForEdit: (id) => '/api/Location/GetDetailsForEdit/' + id,
        ServiceEventTable: (id) => '/api/Location/ServiceEventTable/' + id,
        ServiceEventTableFilters: (id) => `/api/Location/ServiceEventTableFilters/${id}`,
        ServiceProviderTable: (id) => '/api/Location/ServiceProviderTable/' + id,
        LocationAliasTable: (id) => '/api/Location/LocationAliasTable/' + id,
        InventoryTable: (id, IsCylinder, IsCoolingAppliance, IsMeter, ActiveOnly) => '/api/Location/InventoryTable/' + id + '/?IsCylinder=' + IsCylinder + '&IsCoolingAppliance=' + IsCoolingAppliance + '&IsMeter=' + IsMeter + '&ActiveOnly=' + ActiveOnly,
        AddLocation: () => '/api/Location/AddLocation',
        AddLocationAudit: () => '/api/Location/AddLocationAudit',
        AddAlias: (id) => '/api/Location/AddAlias/' + id,
        DeleteAlias: (id) => '/api/Location/DeleteAlias/' + id,
        AddClassification: () => '/api/Location/AddClassification',
        AddAssociation: () => '/api/Location/AddAssociation',
        DeleteLocation: () => '/api/Location/DeleteLocation',
        GetLocationFile: (id) => '/api/Location/GetRegistrationFiles/' + id,
        DeactivateLocation: () => '/api/Location/DeactivateLocation',
        DropDowns: () => '/api/Location/GetDropDowns',
        LocationRegistrationTable: (id) => '/api/Location/LocationRegistrationTable/' + id,
        AddRegistration: () => '/api/Location/AddRegistration/',
        GetLocationAuditDropdowns: (id) => '/api/Location/GetLocationAuditDropdowns/' + id,
        GetLocationsForInstance: () => '/api/Location/GetLocationsForInstance/',
        EditRegistration: (id) => '/api/Location/EditRegistration/' + id,
        DeleteRegistration: (id) => '/api/Location/DeleteRegistration/' + id,
        GetLocationsWithAssetsContactEPA: (reportId) => `/api/Location/GetLocationsWithAssetsContactEPA/${reportId}`,
        GetAvailableServiceProvider: (id) => `/api/Location/${id}/ServiceProviders`,
        AssignServiceProvicer: () => `/api/Location/Assign/ServiceProvider`,
        RevokeServiceProvider: () => `/api/Location/Revoke/ServiceProvider`,
        WorkOrderTable: (id) => '/api/Location/WorkOrderTable/' + id,
        ExportWorkOrderTable: (id) => '/api/Location/WorkOrderTable/Export/' + id,
        ReactivateLocation: () => '/api/Location/ReactivateLocation',
        GetInstanceAssociationsWithLocationsFilterValues: () => '/api/Location/GetInstanceAssociationsWithLocationsFilterValues',
        CountryDropdowns: () => '/api/Location/GetLocationCountryDropdowns',
        GetLocationRegistrationType: () => '/api/Location/GetLocationRegistrationType',
        AddLocationRegistrationType: () => '/api/Location/AddLocationRegistrationType',
        DeleteLocationRegistrationType: (id) => `/api/Location/DeleteLocationRegistrationType/${id}`,
        GetServicerLocations: () => '/api/Location/GetServicerLocations',
        GetServicerLocationFilterValues: () => '/api/Location/GetServicerLocationFilterValues',
        GetServicerLocationsExport: () => '/api/Location/GetServicerLocationsExport',
        RevokeServicerLocation: (id) => `/api/Location/RevokeServicerLocation/${id}`,
    },
    PowerBI: {
        GetReports: () => '/api/PowerBI/Reports',
        GetTrakrefReports: () => '/api/PowerBI/TrakrefReports',
        GetAnalyticReports: () => '/api/PowerBI/AnalyticReports',
        ServiceEventExport: (serviceEventId) => `/api/PowerBI/ServiceEventExport/${serviceEventId}`,
        ContactEpaExport: () => '/api/PowerBI/ContactEpaExport/',
        GetReportSections: () => '/api/PowerBI/ReportSections',
        GetReportBySectionsId: (id) => `/api/PowerBI/GetReportBySectionsId/${id}`,
        ExportGreenchillReport: () => '/api/PowerBI/GreenchillReport',
        EpaDropdown: () => '/api/PowerBI/EpaDropdown',
        EpaSection608Report: () => '/api/PowerBI/EpaSection608Report',
        ChronicallyLeaking608Report: () => '/api/PowerBI/ChronicallyLeaking608Report',
        ExportR3XML: () => '/api/PowerBI/ExportR3XML',
        CARBR3XMLDropdown: () => '/api/PowerBI/CARBR3XMLDropdown',
        IIEE: () => '/api/PowerBI/IIEE',
        IIEETableFilters: () => '/api/PowerBI/IIEE/TableFilters',
        NYDECExport: () => '/api/PowerBI/NYDECExport',
        ServiceBasedScope1: () => '/api/PowerBI/ServiceBasedScope1',
        ServiceBasedScope1Filters: () => '/api/PowerBI/ServiceBasedScope1/Filters',
        LeakRateCompliance: (IsExport) => '/api/PowerBI/LeakRateCompliance?IsExport=' + (IsExport ? 'true' : 'false'),
        LeakRateComplianceDropdown: () => '/api/PowerBI/LeakRateComplianceDropdown',
    },
    Reports: {
        ComplianceCheckup: (year, associationId) => `/api/Reports/ComplianceCheckup/${year}/${associationId}`,
        ValidateLeakInspections: () => '/api/Reports/ValidateLeakInspections/',
    },
    Insights: {
        GetMetrics: () => '/api/Insights/GetMetrics',
    },
    ServiceEvents: {
        ByLocationID: (id) => '/api/User/ServiceEvent/LocationID/' + id,
        ByUserID: (id) => '/api/User/ServiceEvent/UserID/' + id,
        ByUserProfile: (id) => '/api/User/ServiceEvent/UserProfile/' + id,
        TableExport: () => '/api/ServiceEvent/TableExport',
        GetBatchUpdateExport: () => '/api/ServiceEvent/GetBatchUpdateExport',
        BulkUpdate: () => '/api/ServiceEvent/BulkUpdate',
    },
    ServiceEvent: {
        AddServiceEventDropdowns: (workOrderId, serviceEventId) => `/api/ServiceEvent/AddServiceEventDropdowns/${workOrderId}/${serviceEventId}`,
        AddServiceEvent: () => '/api/ServiceEvent/AddServiceEvent',
        DeleteServiceEvent: (id) => `/api/ServiceEvent/DeleteServiceEvent/${id}`,
        Details: (id) => `/api/ServiceEvent/Details/${id}`,
        DetailsForEditing: (id) => `/api/ServiceEvent/DetailsForEditing/${id}`,
        GetWorkOrderIdFromWorkItemId: (id) => `/api/ServiceEvent/GetWorkOrderIdFromWorkItemId/${id}`,
        SiteLeakInspectionDropdown: (id) => `/api/ServiceEvent/SiteLeakInspectionDropdown/${id}`,
        SiteLeakHasSystems: (id) => `/api/ServiceEvent/SiteLeakInpsection/DoesHaveSystems/${id}`,
        AddSiteLeakInspection: () => `/api/ServiceEvent/AddSiteLeakInspection`,
        AddSiteShutdown: () => `/api/ServiceEvent/AddSiteShutdown`,
        ReverseRetrofit: (id) => `/api/ServiceEvent/ReverseRetrofit/${id}`,
        GetUnderRepairWorkItemId: (assetId) => `/api/ServiceEvent/GetUnderRepairWorkItemId/${assetId}`,
        SiteAirFilterTable: (id) => `/api/ServiceEvent/SiteAirFilterTable/${id}`,
        // use the same Data as SiteLeakInspection
        AddSiteAirFilterChangeOut: () => `/api/ServiceEvent/AddSiteAirFilterChangeOut`,
        GetRecentLeaks: (assetId) => `/api/ServiceEvent/GetRecentLeaks/${assetId}`,
    },
    WorkOrder: {
        AddWorkOrderDropdowns: (params = {}) => {
            const queryParams = new URLSearchParams();
            if (params.userLat) queryParams.append('userLat', params.userLat);
            if (params.userLng) queryParams.append('userLng', params.userLng);
            if (params.radiusMiles) queryParams.append('radiusMiles', params.radiusMiles);
            const queryString = queryParams.toString();
            return `/api/WorkOrder/AddWorkOrderDropdowns${queryString ? '?' + queryString : ''}`;
        },
        WorkOrderTableExport: () => '/api/WorkOrder/TableExport',
        Details: (id) => '/api/WorkOrder/Details/' + id,
        WorkOrderTable: () => '/api/WorkOrder/Table',
        ServiceEventTable: (id) => `/api/WorkOrder/ServiceEventTable/${id}`,
        ServiceEventSubTable: (id) => `/api/WorkOrder/ServiceEventSubTable/${id}`,
        TableFilters: () => '/api/WorkOrder/TableFilters',
        Workflow: () => '/api/WorkOrder/WorkFlow',
        AddWorkOrder: () => '/api/WorkOrder/AddWorkOrder',
        ReopenWorkOrder: () => '/api/WorkOrder/Update/Reopen',
        CreateProposal: () => '/api/WorkOrder/Update/CreateProposal',
        UpdateProposal: () => '/api/WorkOrder/Update/UpdateProposal',
        ApproveProposal: () => '/api/WorkOrder/Update/ApproveProposal',
        UpdateApprove: () => '/api/WorkOrder/Update/Approve',
        RejectProposal: () => '/api/WorkOrder/Update/RejectProposal',
        CancelWorkOrder: () => '/api/WorkOrder/Update/Cancel',
        CloseWorkOrder: () => '/api/WorkOrder/Update/Close',
        DeleteWorkOrder: (id) => '/api/WorkOrder/Update/Delete/' + id,
        AssignWorkOrder: () => '/api/WorkOrder/Update/Assign',
        LaborSummary: (id) => '/api/WorkOrder/LaborSummaryTable/' + id,
        WorkActivity: (id) => '/api/WorkOrder/WorkActivity/' + id,
        SupportData: (ID, LocationID, ServicerID) => '/api/WorkOrder/GetSupportData/' + ID + '/' + LocationID + '/' + ServicerID,
        GetServicerTechnicians: (LocationID, ServicerID) => '/api/WorkOrder/GetServicerTechnicians/' + LocationID + '/' + ServicerID,
        DetailsForEditing: (id) => '/api/WorkOrder/DetailsForEditing/' + id,
        UpdateWorkOrder: () => '/api/WorkOrder/Update',
        Export: () => '/api/WorkOrder/Export',
        ValidateWorkOrderNumber: (workOrderNumber) => `/api/WorkOrder/ValidateWorkOrderNumber?workOrderNumber=${workOrderNumber}`,
        BulkUpdate: () => '/api/WorkOrder/BulkUpdate'
    },
    WorkItem: {
        WorkItemTable: () => '/api/WorkItem/Table',
        WorkItemTableTech: () => '/api/WorkItem/TableTech',
        TableFilters: () => '/api/WorkItem/TableFilters',
        DataGridEdit: () => '/api/WorkItem/DataGridEdit',
        TableTechExport: () => '/api/WorkItem/TableTechExport',
    },
    CodesCache: {
        LocationCodes: () => '/api/Codes/LocationCodes',
        ServiceEventDropdowns: () => '/api/Codes/ServiceEventDropdowns',
        UserAccountDropdowns: (id, instanceID) => '/api/Codes/UserAcountDropdowns/' + id + '/' + instanceID,
        Rules: () => '/api/Codes/GetRules',
        AssetDropdowns: () => '/api/Codes/AssetDropdowns',
        EnabledMaterialTypes: () => '/api/Codes/GetEnabledMaterialTypes',
        AssetIdentityType: () => '/api/Codes/AssetIdentityType'
    },
    File: {
        FileList: (type, ref) => `/api/Files/GetFiles/${type}/${ref}`,
        AccountFiles: () => '/api/Files/Accounts',
        UploadFile: () => 'api/Files/Upload/',
        UploadUserFile: () => 'api/Files/Upload/UserFile',
        UploadAccountLogo: () => 'api/Files/Upload/CreateAccountLogo',
        GetFileLink: () => 'api/Files/GetFileLink',
        DeleteFile: () => 'api/Files/DeleteFile',
    },
    User: {
        GetUserDetails: (id) => '/api/User/GetUserDetails/' + id,
        UpdateRequireAdminApproval: (id) => '/api/User/UpdateRequireAdminApproval/' + id,
        UpdateUserDetails: (id) => '/api/User/UpdateUserDetails/' + id,
        CreateUser: (id) => '/api/User/CreateUser',
        DeleteUser: (id) => '/api/User/DeleteUser/' + id,
        DeactivateUser: (id) => '/api/User/Deactivate/' + id,
        ReactivateUser: (id) => '/api/User/Reactivate/' + id,
        ActivateSSO: (id) => '/api/User/ActivateSSO/' + id,
        DeactivateSSO: (id) => '/api/User/DeactivateSSO/' + id,
        UpdateUserPermission: () => '/api/User/UpdateUserPermission',
        ManageAllUsers: () =>  '/api/User/ManageAllUsers',
        ManageAllUsersTableFilters: () =>  '/api/User/ManageAllUsersTableFilters',
        ManageAllUsersExport: () =>  '/api/User/ManageAllUsersExport',
        GetUserDetailsDropDown: (userId) => userId ? `/api/User/GetUserDetailsDropDown?userId=${userId}` : '/api/User/GetUserDetailsDropDown'
    },
    Instance: {
        GetUserInstanceAssociations: () => '/api/Instance/GetUserInstanceAssociations',
        GetByInstanceIdWithLocations: (userId, gettingServicerLocations = false) => `/api/Instance/GetUserInstanceAssociationsWithLocations/${userId}/${gettingServicerLocations}`,
        GetServicerInstanceAssociationsWithLocations: (servicerInstanceId) => `/api/Instance/GetServicerInstanceAssociationsWithLocations/${servicerInstanceId}`,
        GetUserInstanceAssociationsForTable: () => '/api/Instance/GetUserInstanceAssociationsForTable',
        GetClassificationsForTable: () => '/api/Instance/GetClassificationsForTable',
        TableFilters: () => '/api/Instance/TableFilters',
        Export: () => '/api/Instance/Export',
        UpdateInstanceAssociation: (instanceToUpdate) => `/api/Instance/UpdateInstanceAssociation/${instanceToUpdate}`,
        CreateInstanceAssociation: () => '/api/Instance/CreateInstanceAssociation',
        UpdateClassification: (classificationId) => `/api/Instance/UpdateClassification/${classificationId}`,
        AddClassification: () => '/api/Instance/AddClassification',
        ExportClassificationTable: () => '/api/Instance/ExportClassificationTable',
        GetActiveInstance: () => '/api/Instance/GetActiveInstance',
        GetServiceProviders: (getWithInstance, isEditing) => `/api/Instance/GetServiceProviders/${getWithInstance}/${isEditing}`,
        GetServiceProvidersForTable: () => '/api/Instance/GetServiceProvidersForTable',
        ExportServiceProviderTable: () => '/api/Instance/ExportServiceProviderTable',
        LinkServiceProvider: (isEditing) => `/api/Instance/LinkServiceProvider/${isEditing}`,
        ServiceProviderTableFilters: () => '/api/Instance/ServiceProviderTableFilters',
        ManageAccountsTable: () => '/api/Instance/ManageAccountsTable',
        ManageAccountsTableExport: () => '/api/Instance/ManageAccountsTableExport',
        ManageAccountsTableFilters: () => '/api/Instance/ManageAccountsTableFilters',
    },
    Letter: {
        GetContactEpaLetters: () => '/api/Letter/GetContactEpaLetters/',
    },
    AssetIdentity: {
        Create: () => '/api/AssetIdentity/Create',
        Update: () => '/api/AssetIdentity/Update',
        Delete: (id) => `/api/AssetIdentity/Delete/${id}`
    },
    VitalStat: {
        GetInputFields: (assetId) => `/api/VitalStat/GetInputFields/${assetId}`,
        GetTable: (assetId) => `/api/VitalStat/GetTable/${assetId}`,
        Create: () => '/api/VitalStat/Create'
    },
    Notification: {
        Get: () => '/api/Notification/',
        Post: () => '/api/Notification/',
        Update: () => '/api/Notification/Update/',
        UpdateLastSeen: () => '/api/Notification/lastSeen'
    },
    MaterialTransfers: {
        Table: () => '/api/MaterialTransfers/Table',
        InventoryTable: (assetId) => `/api/MaterialTransfers/Table/${assetId}`,
        InventoryTableExport: (assetId) => `/api/MaterialTransfers/Table/Export/${assetId}`,
        TableFilter: (assetId) => `/api/MaterialTransfers/TableFilters/${assetId}`,
        MaterialTranfersTableExport:() => '/api/MaterialTransfers/MaterialTranfersTableExport',
    },
    RegulatedAsset: {
        GetComplianceTable: () => '/api/Asset/Table/RegulatedAssets',
        GetComplianceTableExport: () => '/api/Asset/Table/Export/RegulatedAssets',
        GetComplianceTableFilter: () => '/api/Asset/Table/Filter/RegulatedAssets',
        GetBarGraphRegulatedAssets: () => '/api/Asset/BarGraph/RegulatedAssets'
    },
    RegulatedAssetType: {
        GetAll: () => '/api/RegulatedAssetType/GetAll',
    },
    EmailAlerts: {
        GetByInstance: () => '/api/EmailAlert/GetByInstance',
        GetByInstanceAssociation: () => '/api/EmailAlert/GetByInstanceAssociation',
        GetTable: () => '/api/EmailAlert/GetTable',
        DeleteByEmailAddress: () => '/api/EmailAlert/DeleteByEmailAddress',
        Upsert: () => '/api/EmailAlert/Upsert',
        GetByEmailAddress: (emailAddress) => `/api/EmailAlert/GetByEmailAddress/${emailAddress}`
    },
    SiteUsage: {
        Table: () => '/api/SiteUsage/Table',
        TableExport: () => '/api/SiteUsage/TableExport',
        Filters: () => '/api/SiteUsage/Filters',
    },
    Manufacturers: {
        GetTable: () => '/api/Manufacturer/GetTable',
        TableFilters: () => '/api/Manufacturer/TableFilters',
        ExportManufacturers: () => '/api/Manufacturer/ExportManufacturers',
        AddManufacturerDropdowns: () => '/api/Manufacturer/AddManufacturerDropdowns',
        Create: () => '/api/Manufacturer/Create',
    },
    Manufacturers: {
        GetTable: () => '/api/Manufacturer/GetTable',
        TableFilters: () => '/api/Manufacturer/TableFilters',
        ExportManufacturers: () => '/api/Manufacturer/ExportManufacturers',
        AddManufacturerDropdowns: () => '/api/Manufacturer/AddManufacturerDropdowns',
        Create: () => '/api/Manufacturer/Create',
    },
    MaterialTypes: {
        GetTable: () => '/api/MaterialType/GetTable',
        ToggleMaterialType: () => `/api/MaterialType/ToggleMaterialType`,
        GetMaterialTypeLookups: () => '/api/MaterialType/GetMaterialTypeLookups',
        ExportMaterialTypes: () => '/api/MaterialType/ExportMaterialTypes',
        Upsert: () => '/api/MaterialType/Upsert',
        GetById: (id) => `/api/MaterialType/${id}`,
        ViewMaterialType: () => `/api/MaterialType/ViewMaterialType`,
        ViewMaterialTypeFilter: () => `/api/MaterialType/ViewMaterialTypeFilter`,
        ExportViewMaterialType: () => `/api/MaterialType/ExportViewMaterialType`,
    }
};

export default Routes;